import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_CUSTOMERS } from "../../../utils/constants";
import { CustomerInterface } from "../../../models/TicketModule/Customer";
import customerService from "../../../services/ticketService/customerService";

const useCustomersById = (id: string) =>
  useQuery<CustomerInterface, Error>({
    queryKey: [`${CACHE_KEY_CUSTOMERS}ById`, id],
    queryFn: ({ queryKey }) => {
      const [, customerId] = queryKey;
      return customerService.GetById(customerId as string);
    },
    enabled: !!id,
  });

export default useCustomersById;
